import React from 'react';

import { Alert } from 'antd';
import styled from '@emotion/styled';
import { useHeidiSession } from '@components/Clinicians/Session/hooks/useHeidiSession';
import { useTranslation } from 'react-i18next';

const StyledAlert = styled(Alert)`
  width: 90%;
  .ant-alert-message {
    font-weight: 700;
  }
`;

export const AITranscribeAlert = () => {
  const { hasHeidiError } = useHeidiSession();
  const { t } = useTranslation('common');
  if (!hasHeidiError) return null;

  return (
    <StyledAlert
      message={t('AI Service Unavailable')}
      description={
        <>
          <p style={{ margin: '0 0 12px 0' }}>
            {t('The Heidi AI transcription service is currently experiencing issues and cannot generate notes today.')}
          </p>
          <p style={{ margin: 0, fontWeight: 600 }}>
            {t('You can still complete your consultation and manually enter notes.')}
          </p>
        </>
      }
      type="error"
      showIcon
    />
  );
};
